"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[606],{

/***/ 2606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_photo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(727);
/* harmony import */ var _components_phrase__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1995);





function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var Hero = function(param) {
    var _data = param.data, data = _data === void 0 ? {} : _data;
    var style = data.style, phrase = data.phrase, images = data.images;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), dividerMaxWidth = ref[0], setDividerMaxWidth = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        // get the width of the words
        if (ref1.current) {
            var containerWidth = ref1.current.getBoundingClientRect().width, words = ref1.current.querySelectorAll("div.px-gutter"), wordsWidth = 0;
            _toConsumableArray(words).map(function(word, idx) {
                wordsWidth += word.getBoundingClientRect().width;
            });
            setDividerMaxWidth(containerWidth - wordsWidth);
        }
    });
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("hero", "px-gutter", "py-gutter", "pt-0", "max-h-screen", "h-[73vh]", "sm:h-[calc(100vh-73px-50px)]", "bg-gray", "relative", "z-20"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("flex", "flex-col", "relative", "w-full", "h-full", "text-center"),
            children: [
                style == "default" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("mt-10", "mb-6", "mx-auto", "w-full"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "hidden sm:block",
                                    children: phrase && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_phrase__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        phrase: phrase,
                                        dividerMaxWidth: "50vw",
                                        reverse: true,
                                        delay: "0.3",
                                        typeStyle: "text-jumbo-mobile md:text-jumbo whitespace-nowrap"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "block sm:hidden",
                                    children: phrase && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_phrase__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        hideLast: true,
                                        dividerMaxWidth: "100px",
                                        vertical: true,
                                        phrase: phrase,
                                        typeStyle: "text-jumbo-mobile md:text-jumbo"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("relative", "image-wrap", "h-full", "rounded-default", "overflow-hidden"),
                            children: images.map(function(image, idx) {
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_photo__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    photo: image,
                                    width: 1600,
                                    layout: "fill"
                                }, idx);
                            })
                        })
                    ]
                }),
                style == "phraseOverlay" && phrase && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("relative", "image-wrap", "h-full", "rounded-default", "overflow-hidden"),
                        children: [
                            phrase && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("absolute", "bottom-0", "z-10", "flex", "justify-center", "w-full", "px-gutter", "text-center"),
                                children: phrase && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            ref: ref1,
                                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("text-center", "mb-5", "hidden", "md:block", "w-full", "absolute", "bottom-0"),
                                            children: dividerMaxWidth && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_phrase__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                phrase: phrase,
                                                color: "#ffffff",
                                                dividerMaxWidth: "".concat(dividerMaxWidth, "px"),
                                                delay: 0.4,
                                                duration: "3",
                                                ease: "easeInOut",
                                                phraseMaxWidth: false,
                                                typeStyle: "text-jumbo-mobile md:text-jumbo text-white w-full"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("grid", "text-center", "mb-10", "md:hidden"),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_phrase__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                phrase: phrase,
                                                vertical: true,
                                                hideLast: true,
                                                color: "#ffffff",
                                                dividerMaxWidth: "100px",
                                                typeStyle: "text-jumbo-mobile-xs xs:text-jumbo-mobile md:text-jumbo text-white"
                                            })
                                        })
                                    ]
                                })
                            }),
                            images.map(function(image, idx) {
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_photo__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    photo: image,
                                    width: 1200,
                                    layout: "fill"
                                }, idx);
                            })
                        ]
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (Hero);


/***/ })

}]);